// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__26_lb","title":"Info_title__ztXXU","links":"Info_links__3o0g4","link":"Info_link__xLKOv","logo":"Info_logo__1iPld"};